import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme, _params, classes) => ({
  root: {},
  container: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0px',
    boxShadow: '0px 6px 16px 0px rgba(21, 12, 115, 0.06)',
    width: 'fit-content',
    borderRadius: '24px'
  },
  label: {
    background: theme.palette.primary.primary200,
    padding: '6px 8px 6px 13px',
    borderRadius: '24px 0px 0px 24px',
    fontWeight: 600,
    fontSize: '14px',
    color: theme.palette.black.dark,
    lineHeight: 1.3
  },
  valuesContainer: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0px 24px 24px 0px',
    background: 'white',
    cursor: 'pointer'
  },
  typeContainer: {
    userSelect:'none'
  },
  values: {
    fontSize: '14px',
    color: theme.palette.grey.grey400,
    padding: '6px 8px 6px 8px',
  },
  editIcon: {
    padding: '5px 5px 5px 0px'
  },
  multipleValue: {
    margin: '0px 5px'
  },
  contextGraphContainer: {
    background: "transparent",
    boxShadow: 'unset',
    margin: '0px',
    width: '100%',
    padding: '4px 14px',
    [`& .${classes.typeContainer}`]: {
    },
    [`& .${classes.label}`]: {
      background: "transparent",
      color: theme.palette.primary.primary800,
      fontSize: '10px',
      fontWeight: 600,
      padding: '0px 0px 0px 5px',
      width: '100px',
      textAlign: 'left',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginRight: '5px',
      paddingLeft: '5px'
    },
    [`& .${classes.values}`]: {
      color: theme.palette.grey.grey500,
      fontSize: '10px',
      padding: '0px'
    },
    [`& .${classes.valuesContainer}`]: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    [`& .${classes.editIcon}`]: {
      marginLeft: 'auto',
      height: '15px',
      padding: 0
    },
  },

}));

export default useStyles;
